import { Badge } from '@/components/ui/badge';
import { Clock, ArrowRight } from 'lucide-react';

interface RolloverBadgeProps {
  type: 'rollover' | 'split' | 'auto-rolled' | 'paused-overnight' | 'promise-exceeded' | 'rollover-pending';
  className?: string;
}

export function RolloverBadge({ type, className = '' }: RolloverBadgeProps) {
  const badges = {
    'rollover': {
      label: 'Rollover',
      icon: ArrowRight,
      variant: 'secondary' as const,
      color: 'bg-orange-500/10 text-orange-700 dark:text-orange-300'
    },
    'split': {
      label: 'Split',
      icon: Clock,
      variant: 'secondary' as const,
      color: 'bg-blue-500/10 text-blue-700 dark:text-blue-300'
    },
    'auto-rolled': {
      label: 'Auto-Rolled',
      icon: ArrowRight,
      variant: 'secondary' as const,
      color: 'bg-green-500/10 text-green-700 dark:text-green-300'
    },
    'paused-overnight': {
      label: 'Paused Overnight',
      icon: Clock,
      variant: 'secondary' as const,
      color: 'bg-yellow-500/10 text-yellow-700 dark:text-yellow-300'
    },
    'promise-exceeded': {
      label: 'Promise Exceeded',
      icon: Clock,
      variant: 'destructive' as const,
      color: 'bg-red-500/10 text-red-700 dark:text-red-300'
    },
    'rollover-pending': {
      label: 'Rollover Pending',
      icon: Clock,
      variant: 'outline' as const,
      color: 'bg-gray-500/10 text-gray-700 dark:text-gray-300'
    }
  };

  const config = badges[type];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={`${config.color} ${className}`}>
      <Icon className="w-3 h-3 mr-1" />
      {config.label}
    </Badge>
  );
}
